import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    events: {}
  },
  mutations: {
    setEvents(state, payload) {

      state.events[payload[0].race_id] = {
        time: new Date().toLocaleString(),
        participants: payload,
      };

    },
    setEventsEmpty(state, payload) {

      delete state.events[payload[0].race_id];

    },
  },
  actions: {
    async setEventsLocal({ commit }, payload) {
      commit("setEvents", payload);
    },
    async clearParticipants({ commit }, payload) {
      commit("setEventsEmpty", payload);
    }
  },
  getters: {
    events(state) {
      return state.events;
    },
  }
};
